import { useState } from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "@/components/ui/dialog";
import {
  TERMS_OF_USE, PRIVACY_NOTICE, CLINICAL_USE_SHORT,
} from "@/lib/legalContent";
import { useSetting } from "@/lib/appSettings";

const TABS = {
  terms:    { title: "Termos de Utilização", body: TERMS_OF_USE },
  privacy:  { title: "Política de Privacidade", body: PRIVACY_NOTICE },
  clinical: { title: "Uso Clínico", body: CLINICAL_USE_SHORT },
};

export default function LegalFooter() {
  const [open, setOpen] = useState(null); // 'terms' | 'privacy' | 'clinical' | null
  const current = open ? TABS[open] : null;
  const copyright = useSetting("footer.copyright", "MIO · Mapping Intelligence for Osteopathy");
  return (
    <>
      <footer
        data-testid="legal-footer"
        className="px-4 md:px-8 py-3 md:py-4 border-t border-slate-900/80 text-[10px] sm:text-[11px] text-slate-500 flex items-center justify-between gap-2 sm:gap-3 flex-wrap"
      >
        <span className="text-slate-500 truncate max-w-full sm:max-w-none">© {new Date().getFullYear()} {copyright}</span>
        <nav className="flex items-center gap-3 sm:gap-4 flex-wrap">
          <button data-testid="footer-terms-btn" onClick={() => setOpen("terms")} className="hover:text-slate-300 transition">Termos</button>
          <span className="text-slate-500">·</span>
          <button data-testid="footer-privacy-btn" onClick={() => setOpen("privacy")} className="hover:text-slate-300 transition">Privacidade</button>
          <span className="text-slate-500">·</span>
          <button data-testid="footer-clinical-btn" onClick={() => setOpen("clinical")} className="hover:text-slate-300 transition">Uso clínico</button>
        </nav>
      </footer>

      <Dialog open={!!open} onOpenChange={(v) => !v && setOpen(null)}>
        <DialogContent className="bg-slate-950 border-slate-800 text-slate-100 max-w-2xl" data-testid="legal-modal">
          {current && (
            <>
              <DialogHeader>
                <DialogTitle className="font-display text-slate-50">{current.title}</DialogTitle>
                <DialogDescription className="text-slate-500">Versão sintética · texto completo em Definições → Termos e Condições.</DialogDescription>
              </DialogHeader>
              <div className="text-sm text-slate-300 leading-relaxed whitespace-pre-line max-h-[60vh] overflow-y-auto pr-2">
                {current.body}
              </div>
            </>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
